import React from "react";
import { loaderSVG } from "../../../assets/images";
import { sortBydate } from "../../../Helpers/Chat/RecentChat.js";
import {Title} from "../Common/BrowserTitle.js";
import RecentChat from "./RecentChat";
import RecentSearch from "./RecentSearch";
import {
  getValidSearchVal,
  capitalizeFirstLetter,
  isConnStateEqualTo,
} from "../../../Helpers/Utility";
import {
  getUserInfoForSearch,
  getDataFromRoster,
} from "../../../Helpers/Chat/User";
import { isSingleChat } from "../../../Helpers/Chat/ChatHelper";
import {
  CONNECTION_STATE_CONNECTING,
  CONNECTION_STATE_CONN_FAILED,
  CONNECTION_STATE_ERROR_OCCURED,
} from "../../../Helpers/Chat/Constant";
import { useSelector } from "react-redux";
import { store } from "../../../Redux/store";
import { addrecentChatItems } from "../../../Redux/feature/recentChatItemsSlice";

const RecentChatSection = (props = {}) => {
  const getstore = useSelector((state) => state);
  const {
      recentChatData = {},
      recentChatData: { id: recentchatId, data: recentChatArray = [] } = {},
      rosterData = {},
      rosterData: { id: rosterId, data: rosterDataArray = [] } = {},
      appOnlineStatus : {isAppOnline},
      groupsData: { data: groupsDataArrayStore = [] },
    } = getstore;
  const {
    commonData = {},
    commonData: { data: { isArchived = false } = {} } = {},
    newChatStatus,
    pageType = "recent",
    searchFlag,
    callUserJID,
    callType,
    callMode,
    callStatus,
    handlePopupState
  } = props;

  const [recentChatSectionState, setRecentChatSection] = React.useState({
    loader: true,
    searchEnable: false,
    searchValue: "",
    recentChatNames: [],
    recentChatItems: [],
    filteredContacts: [],
    filteredRecentChat:[],
    constructedRecentChat:[],
  });

  const {
    loader,
    searchEnable,
    searchValue,
    recentChatNames,
    recentChatItems,
  } = recentChatSectionState;

  let timer = 0;
  let chatExist = false;

  const filterUserNameFromRecent = (recentChatArrayForUser) => recentChatArrayForUser.map((chat) => chat.fromUserId);

  const filterRosterByUserNames = (recentChatArrayFilterUserName, rosterDataArrayFilterUserName) => {
    const recentChatNamesFilter = filterUserNameFromRecent(recentChatArrayFilterUserName);
    let rosterPP =  rosterDataArrayFilterUserName.filter((profile) => {
      const rosterJid = profile.username ? profile.username : profile.userId;
      return recentChatNamesFilter.indexOf(rosterJid) > -1;
    });
    return rosterPP
  };

  const filterProfileFromRoster = (filteredRoaster, messageFrom) => {
    return getDataFromRoster(messageFrom);
  };

  const filterProfileFromGroup = (messageFrom) => {
    return (
      groupsDataArrayStore &&
      groupsDataArrayStore.find((groups) => messageFrom === groups.groupId)
    );
  };

  const getRoaster = (chatType = "groupchat", messageFrom = "") => {
    const messageType = {
      groupchat: filterProfileFromGroup
    };
    return messageType[chatType] && messageType[chatType](messageFrom);
  };

  const constructRecentChatItems = (recentChatArrayConstruct, filteredRoasterConstruct) => {
    let recent = [];
    sortBydate([...recentChatArrayConstruct]).map(async (chat) => {
      let data = {};
      if (isSingleChat(chat.chatType)) {
        data = filterProfileFromRoster(filteredRoasterConstruct, chat.fromUserId);
      } else {
        data = getRoaster(chat.chatType, chat.fromUserId);
      }
      recent.push({
        recent: chat,
        roster: data || {},
      });
    });
    // setRecentChatSection({
    //   ...recentChatSectionState,constructedRecentChat:recent.filter((eachmessage) => eachmessage)
    // })
    return recent.filter((eachmessage) => eachmessage);
  };

  React.useEffect(() => {
    const isRefreshed = isArchived !== commonData?.data?.isArchived;
    if (
      rosterData.id ||
      recentChatData.id ||
      isRefreshed
      ) {
        if (!rosterId || !recentchatId) return;
        const filteredRoaster = filterRosterByUserNames(
        recentChatArray,
        rosterDataArray
        );
        let recentChatItemsInitial = constructRecentChatItems(recentChatArray,filteredRoaster);
        let recentChatNamesInitial = filterUserNameFromRecent(recentChatArray);
      setRecentChatSection(
        { ...recentChatSectionState,
          recentChatItems: recentChatItemsInitial,
          recentChatNames: recentChatNamesInitial,
          loader: false,
        }
      );
      store.dispatch(addrecentChatItems(constructRecentChatItems(recentChatArray,filteredRoaster)))
      /**
       * store.dispatch(addRosterDataUpdate(recentChatItems));
       * store.dispatch(addRecentRosterUpdate(recentChatItemsInitial));
       * recentChatItemss = recentChatItemsInitial
       * props.updateRoster({ recentChatNames, recentChatItems });
       */
      

      return;
    }
    return (()=>clearTimeout(timer))
  }, [rosterData,recentchatId]);

  React.useEffect(() => {
    if(recentChatSectionState.recentChatItems.length > 0){
      setRecentChatSection({
        ...recentChatSectionState,
        recentChatItems: recentChatItems,
        recentChatNames: recentChatNames,
      });
    }
    searchValue && searchFilterList(searchValue);
  }, [recentChatItems,recentChatNames]);

  const recentChatSearchFilter = (searchWith) => {
    chatExist = false;
    return recentChatItems.map((item) => {
      const { roster } = item;
      const regexList = getUserInfoForSearch(roster);
      const updateSearch = regexList.find((str) => {
        if (!str) return false;
        return str.search(new RegExp(searchWith, "i")) !== -1;
      });
      if (updateSearch) {
        item.hidden = false;
        chatExist = true;
        return item;
      }
      item.hidden = true;
      return item;
    });
  };

  const contactsSearch = (searchTerm) => {
    const { data } = rosterData;
    if (!data) return [];
    return data.filter((item) => {
      const rosterJid = item.username ? item.username : item.userId;
      if (recentChatNames.indexOf(rosterJid) > -1) {
        return false;
      }

      const regexList = getUserInfoForSearch(item);
      return regexList.find((str) => {
        if (!item.isFriend || !str) return false;
        return str.search(new RegExp(searchTerm, "i")) !== -1;
      });
    });
  };

  const searchFilterList = (searchValueFilter, refreshUnreadCountFilter) => {
    let searchWith = getValidSearchVal(searchValueFilter);
    clearTimeout(timer);
    timer = setTimeout(() => {
      const updatedList = recentChatSearchFilter(searchWith);
      const filteredContactsSearch = contactsSearch(searchWith);
      setRecentChatSection({
        ...recentChatSectionState,
        searchEnable: searchValueFilter === "" ? false : true,
        searchValue: searchValueFilter,
        filteredRecentChat: updatedList,
        filteredContacts: filteredContactsSearch,
        refreshUnreadCountFilter,
      });
    }, 0);
  };


  const updatedRecentChat = searchEnable ? recentChatSectionState.filteredRecentChat : recentChatItems;
  const loaderStyle = {
    width: 80,
    height: 80,
  };
  if (loader) {
    return (
      <div className="loader-container">
        <img src={loaderSVG} alt="loader" style={loaderStyle} />
      </div>
    );
  }

  return (
    <React.Fragment>
      <div style={{ display: !newChatStatus ? "none" : "" }}>
        {pageType === "recent" && searchFlag && (
          <RecentSearch search={(value) => searchFilterList(value)} />
        )}


        {(!isAppOnline ||
          isConnStateEqualTo([
            CONNECTION_STATE_CONNECTING,
            CONNECTION_STATE_CONN_FAILED,
            CONNECTION_STATE_ERROR_OCCURED,
          ])) && (
            <div className="networkoffline">
              {!isAppOnline
                ? "Please check your Internet connection"
                : capitalizeFirstLetter(
                  CONNECTION_STATE_CONNECTING.toLocaleLowerCase()
                )}
            </div>
          )}
        {
          <div
            className={` chat-list ${!isAppOnline ||
              isConnStateEqualTo([
                CONNECTION_STATE_CONNECTING,
                CONNECTION_STATE_CONN_FAILED,
                CONNECTION_STATE_ERROR_OCCURED,
              ])
              ? "offline"
              : ""
              } ${pageType === "archive" ? "archive" : ""} ${pageType === "archive" &&
                updatedRecentChat.length === 0 &&
                !searchValue
                ? " no-chat-archive "
                : ""
              } ${pageType !== "archive" &&
                updatedRecentChat.length === 0 &&
                !searchValue
                ? " no-chat "
                : ""
                } ${searchFlag ? "  " : " search_restrict " }`}
                >
            <RecentChat
              pageType="recent"
              searchTerm={searchValue}
              recentChatItems={updatedRecentChat}
              recentChatExist={chatExist}
              callUserJID = {callUserJID}
              handleShowCallScreen={props.handleShowCallScreen}
              callStatus={callStatus}
              callType={callType}
              callMode={callMode}
              handlePopupState={handlePopupState}
            />

          </div>
        }
        <Title />
      </div>
    </React.Fragment>
  );
};

export default RecentChatSection;
